<template>
  <div class="container page victoria-record-page money-log-page">
    <van-nav-bar title="Deposit history" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="No more data"
        @load="onLoad"
      >
        <div class="record-item" v-for="(item, index) in list" :key="index">
          <div class="record-content">
            <div class="left-info">
              <p class="memo">{{ item.memo }}</p>
              <p class="time">{{ item.createtime }}</p>
            </div>
            <div class="right-amount">
              <span :class="item.type === 1 ? 'amount-add' : 'amount-reduce'">{{ item.type === 1 ? '+' : '-' }}{{ item.money }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onLoad() {
      this.getMoneyLog();
    },
    getMoneyLog() {
      this.$http({
        method: 'get',
        url: 'getUserMoneyLog',
        data:{page:this.page},
      }).then(res => {
        if (res.code === 200) {
          this.list = this.list.concat(res.data);
          this.loading = false;
          this.page++;
          if (res.data.length === 0) {
            this.finished = true;
          }
        }
      }).catch(() => {
        this.loading = false;
        this.finished = true;
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
  font-size: 0.48rem;
}

.main-content {
  padding: 0;
}

.record-item {
  background: #fff;
  padding: 0.4rem 0.4rem;
  border-bottom: 0.02667rem solid #f5f5f5;
}

.record-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-info {
  flex: 1;
}

.memo {
  font-size: 0.42333rem;
  color: #333;
  margin: 0 0 0.2rem 0;
  font-weight: bold;
}

.time {
  font-size: 0.38rem;
  color: #2b2b2b;
  margin: 0;
}

.right-amount {
  text-align: right;
}

.amount-add {
  font-size: 0.42667rem;
  color: #e74c3c;
}

.amount-reduce {
  font-size: 0.42667rem;
  color: #00c853;
}

::v-deep .van-list__finished-text {
  font-size: 0.32rem;
  color: #999;
}
</style>
